import {
    collection,
    getDocs,
    query,
    where,
    orderBy,
    doc,
    getDoc
} from "firebase/firestore";

import { firestore } from "../firebase";
import { TrackData } from "../types/Types";

export const GenreFeedService = {

    async fetchUniqueGenres(): Promise<string[]> {
        try {
            const trackLinksRef = collection(firestore, "trackLinks");
            const snapshot = await getDocs(trackLinksRef);

            const allGenres = snapshot.docs
                .map((doc) => doc.data().genre)
                .filter((genre): genre is string => typeof genre === "string" && genre.length > 0);

            const uniqueGenres = Array.from(new Set(allGenres)).sort();
            return uniqueGenres;
        } catch (error) {
            console.error("Error fetching unique genres:", error);
            return [];
        }
    },

    async fetchTracksByGenre(genre: string): Promise<TrackData[]> {
        try {
            const tracksRef = collection(firestore, "trackLinks");

            const q = query(
                tracksRef,
                where("genre", "==", genre),
                orderBy("releaseDate", "desc")
            );

            const snapshot = await getDocs(q);

            const tracks = await Promise.all(snapshot.docs.map(async (d) => {
                const data = d.data();

                let finalUserName = data.userName || "";

                if (!finalUserName && data.userId) {
                    try {
                        const userRef = doc(firestore, "users", data.userId);
                        const userSnap = await getDoc(userRef);
                        if (userSnap.exists()) {
                            finalUserName = userSnap.data().userName || "";
                        }
                    } catch (err) {
                        console.error(`Error fetching user profile for ${data.userId}`, err);
                    }
                }

                return {
                    id: d.id,
                    userId: data.userId || "",
                    stateID: data.stateID || 0,
                    regionID: data.regionID || 0,
                    coverArtUrl: data.coverArtUrl || "",
                    userName: finalUserName || "Unknown User",
                    trackTitle: data.trackTitle || data.title || "Unknown Title",
                    artistName: data.artistName || data.artist || "Unknown Artist",
                    featureArtists: data.featureArtists || [],
                    genreName: data.genre || "",
                    releaseType: data.releaseType || "Single",
                    platformLinks: data.platformLinks || {},
                    moodTags: data.moodTags || []
                } as TrackData;
            }));

            return tracks;

        } catch (error) {
            console.error(`Error fetching tracks for genre ${genre}:`, error);
            return [];
        }
    }
};